import { scheduleRunsFactory } from '@eas/common-web';
import { ExportTags } from '../../../../common/export-tags';

export const ScheduleRuns = scheduleRunsFactory(ExportTags.SCHEDULE_RUNS_GRID);
